// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"273":"1e08ff4c","610":"476fb8a6"}[chunkId] + ".chunk.js";
};